import { isCreateIndividualObligationResponse, } from '@urbanik/api-contracts';
export class IndividualObligationApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'IndividualObligationApiError';
    }
}
export async function createIndividualObligation(base, input) {
    let response;
    try {
        response = await fetch(`${base.replace(/\/$/, '')}/identity/collections/obligations`, {
            method: 'POST',
            credentials: 'include',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(input),
        });
    }
    catch {
        throw new IndividualObligationApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    const body = await response.json();
    if (!response.ok) {
        const message = typeof body === 'object' &&
            body !== null &&
            typeof body.message === 'string'
            ? body.message
            : 'No pudimos crear la obligación.';
        throw new IndividualObligationApiError(response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : response.status === 404
                    ? 'not-found'
                    : response.status === 400
                        ? 'validation'
                        : 'unavailable', message);
    }
    if (!isCreateIndividualObligationResponse(body))
        throw new IndividualObligationApiError('invalid', 'La obligación recibida no es válida.');
    return body;
}
